import React, { useEffect, useState } from 'react';
import { Box, Typography, IconButton, Dialog } from '@mui/material';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import DownloadIcon from '@mui/icons-material/Download';
import CloseIcon from '@mui/icons-material/Close';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';

const MessageAttachment = React.memo(({ fileUrl }) => {
  const [openPreview, setOpenPreview] = useState(false);

  useEffect(() => {
    console.log(fileUrl);
  }, [fileUrl]);

  if (!fileUrl) return null;

  const extension = fileUrl.split('.').pop().toLowerCase();
  const isImage = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(
    extension,
  );
  const isVideo = ['mp4', 'webm', 'ogg', 'mov'].includes(extension);
  const filename = decodeURIComponent(fileUrl.split('/').pop());

  if (isImage) {
    return (
      <>
        {/* thumbnail u poruci */}
        <Box
          component="img"
          src={fileUrl}
          alt="slika"
          onClick={(e) => {
            e.stopPropagation(); // da ne pokrene parent evente
            setOpenPreview(true);
          }}
          loading="lazy"
          sx={{
            width: '100%',
            maxHeight: 300,
            borderRadius: 1,
            objectFit: 'contain',
            cursor: 'zoom-in',
            mb: 0.5,
          }}
        />

        {/* download dugme */}
        <IconButton
          component="a"
          href={fileUrl}
          download
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: 'primary.main', p: 0 }}
        >
          <DownloadIcon fontSize="small" />
        </IconButton>

        {/* DIALOG koji sadrži viewer sa ZOOM/PINCH/PAN */}
        <Dialog
          open={openPreview}
          onClose={() => setOpenPreview(false)}
          maxWidth="sm"
          fullWidth
        >
          <Box
            sx={{
              position: 'relative',
              bgcolor: '#000',
              p: 0,
              // fiksna visina platna da bi pan/zoom imali prostor
              height: '90vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden',
            }}
            // spreči right-click meni parenta, dugi pritisak itd.
            onContextMenu={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            onTouchStart={(e) => e.stopPropagation()}
          >
            {/* close dugme */}
            <IconButton
              onClick={() => setOpenPreview(false)}
              sx={{
                position: 'absolute',
                top: 8,
                right: 8,
                color: '#fff',
                zIndex: 2,
              }}
            >
              <CloseIcon />
            </IconButton>

            {/* Viewer */}
            <TransformWrapper
              minScale={0.5}
              maxScale={6}
              initialScale={1}
              wheel={{ wheelEnabled: true, step: 0.2 }}
              pinch={{ pinchEnabled: true }}
              doubleClick={{ disabled: true }} // da dvoklik ne “iskače” iz dijaloga
              panning={{ velocityDisabled: true }} // glatko povlačenje
              limitToBounds={false} // dozvoli pomeranje i van centra kad je uvećano
            >
              {({ zoomIn, zoomOut, resetTransform }) => (
                <>
                  {/* opcione kontrole (zoom +/- i reset) */}
                  <Box
                    sx={{
                      position: 'absolute',
                      bottom: 16,
                      left: '50%',
                      transform: 'translateX(-50%)',
                      display: 'flex',
                      gap: 1,
                      bgcolor: 'rgba(0,0,0,0.5)',
                      p: 1,
                      borderRadius: 2,
                      zIndex: 2,
                    }}
                    onMouseDown={(e) => e.stopPropagation()}
                    onTouchStart={(e) => e.stopPropagation()}
                  >
                    {/* <IconButton onClick={zoomOut} sx={{ color: '#fff' }}>
                      −
                    </IconButton>
                    <IconButton onClick={resetTransform} sx={{ color: '#fff' }}>
                      ⟲
                    </IconButton>
                    <IconButton onClick={zoomIn} sx={{ color: '#fff' }}>
                      ＋
                    </IconButton> */}
                  </Box>

                  <TransformComponent
                    wrapperStyle={{
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    contentStyle={{
                      // bolje renderovanje
                      willChange: 'transform',
                    }}
                  >
                    <img
                      src={fileUrl}
                      alt="preview"
                      style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain',
                        userSelect: 'none',
                        pointerEvents: 'auto',
                      }}
                      draggable={false}
                      onDragStart={(e) => e.preventDefault()}
                    />
                  </TransformComponent>
                </>
              )}
            </TransformWrapper>
          </Box>
        </Dialog>
      </>
    );
  }

  if (isVideo) {
    return (
      <>
        <Box
          onClick={() => setOpenPreview(true)}
          sx={{
            width: '100%',
            borderRadius: 1,
            cursor: 'pointer',
            backgroundColor: '#000',
            mb: 0.5,
          }}
        >
          <video
            src={fileUrl}
            style={{ width: '100%', maxHeight: 300, borderRadius: 4 }}
            muted
            preload="metadata"
          />
        </Box>

        <IconButton
          component="a"
          href={fileUrl}
          download
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: 'primary.main', p: 0 }}
        >
          <DownloadIcon fontSize="small" />
        </IconButton>

        <Dialog
          open={openPreview}
          onClose={() => setOpenPreview(false)}
          maxWidth="lg"
          fullWidth
        >
          <Box sx={{ position: 'relative', p: 2, bgcolor: '#000' }}>
            <IconButton
              onClick={() => setOpenPreview(false)}
              sx={{
                position: 'absolute',
                top: 8,
                right: 8,
                color: '#fff',
                zIndex: 2,
              }}
            >
              <CloseIcon />
            </IconButton>
            <video
              src={fileUrl}
              controls
              autoPlay
              style={{ width: '100%', maxHeight: '90vh', borderRadius: 4 }}
            >
              <track kind="captions" />
            </video>
          </Box>
        </Dialog>
      </>
    );
  }

  // Default: fajl (dokument)
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
      <InsertDriveFileIcon fontSize="small" color="action" />
      <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
        {filename}
      </Typography>
      <IconButton
        component="a"
        href={fileUrl}
        download
        target="_blank"
        rel="noopener noreferrer"
        sx={{ color: 'primary.main', p: 0 }}
      >
        <DownloadIcon fontSize="small" />
      </IconButton>
    </Box>
  );
});

export default MessageAttachment;
